import React from 'react';
import { Subtitle } from '../Common/Subtitle';
import { Box } from '../Common/Box';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import { LabeledValue } from '../Common/LabeledValue';
import { Link } from 'react-router-dom';
import { InvoiceProfile } from '~/types/models';

export interface InvoiceInformationPanelProps {
  invoiceProfile?: InvoiceProfile;
}

export function InvoiceInformationPanel({
  invoiceProfile,
}: InvoiceInformationPanelProps) {
  return (
    <div className='flex flex-col gap-y-4 w-full max-w-[800px]'>
      <Subtitle label='Invoice information' />
      <div className='text-base v2-text-neutral-900'>
        These details are optional. The details entered will appear on your
        invoice.
      </div>
      <Box className='flex flex-col xmd:flex-row gap-y-2'>
        <div className='w-full xmd:w-2/12 flex flex-row gap-x-2'>
          <LabeledValue label='Billing name' value={invoiceProfile?.name} />
        </div>
        <div className='w-full xmd:w-3/12 flex flex-row gap-x-2'>
          <LabeledValue label='Tax ID' value={invoiceProfile?.tax_id} />
        </div>
        <div className='w-full xmd:w-4/12'>
          <LabeledValue
            label='Billing address'
            value={invoiceProfile?.address}
          />
        </div>
        <div className='w-full xmd:w-3/12 flex justify-end'>
          <Link className='w-full xmd:w-auto' to='/billing/invoices/edit'>
            <Button
              variant={ButtonVariant.Secondary}
              className='w-full v2-text-neutral-900 py-2'
            >
              Update information
            </Button>
          </Link>
        </div>
      </Box>
    </div>
  );
}
